export default "__VITE_ASSET__Cnv9kSBC__"